module.exports = __webpack_public_path__ + "img/radio_rmf_fm.af08420e.jpeg";